import { render, staticRenderFns } from "./past-promotions.vue?vue&type=template&id=5e92729e"
import script from "./past-promotions.vue?vue&type=script&lang=js"
export * from "./past-promotions.vue?vue&type=script&lang=js"
import style0 from "./past-promotions.vue?vue&type=style&index=0&id=5e92729e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports